import React from 'react';
import { BsJournalText, BsStarFill, BsStar, BsFileText, BsPeople } from 'react-icons/bs';
import './SummaryCard.css';

const getIcon = (type) => {
  switch (type) {
    case 'totalArticles':
      return <BsJournalText className="summary-card-icon" />;
    case 'q1Articles':
      return <BsStarFill className="summary-card-icon" />;
    case 'q2Articles':
      return <BsStar className="summary-card-icon" />;
    case 'mrArticles':
      return <BsFileText className="summary-card-icon" />;
    case 'facultyStats':
      return <BsPeople className="summary-card-icon" />;
    default:
      return null;
  }
};

const getCardClass = (type) => {
  switch (type) {
    case 'totalArticles':
      return 'primary';
    case 'q1Articles':
      return 'success';
    case 'q2Articles':
      return 'info';
    case 'mrArticles':
      return 'warning';
    case 'facultyStats':
      return 'secondary';
    default:
      return 'primary';
  }
};

const SummaryCard = ({ type, title, description, data }) => {
  return (
    <div className={`summary-card ${getCardClass(type)}`}>
      <div className="summary-card-header">
        {getIcon(type)}
        <div className="summary-card-titles">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </div>
      <div className="summary-card-content">
        {Object.entries(data).map(([key, value]) => (
          <div key={key} className="summary-stat">
            <span className="stat-label">{key}</span>
            <span className="stat-value">{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummaryCard;
